<!-- Heading -->
<div class="item-heading-large">{{ rowData.heading }}</div>

<!-- Subheadings -->
<div
   class="item-subheading"
   *ngFor="let subheading of rowData.subheadings">
   {{ subheading }}
</div>

<!-- Flex row -->
<div class="d-flex flex-row flex-nowrap mt-4 gap-3">
   <!-- Textarea -->
   <div style="flex: 0.6">
      <div class="form-group">
         <label
            for="notesTextarea"
            class="dropdown-heading">
            Notes
            <span class="required-asterisk">*</span>
         </label>
         <vc-textarea
            [(ngModel)]="rowData.textareaValue"
            [rows]="6"
            [attr.maxLength]="maxLength"
            [required]="true"
            placeholder=""></vc-textarea>

         <small class="text-muted d-block mt-1">{{ rowData.textareaValue?.length || 0 }} / {{ maxLength }}</small>
      </div>
   </div>

   <!-- Dropdowns -->
   <div
      style="flex: 0.4"
      class="ml-5">
      <div class="dropdown-heading mb-2">
         Top {{ rowData.dropdowns }} {{ rowData.heading }}
         <span class="required-asterisk">*</span>
      </div>
      <div class="feedbackRow">
         <div *ngFor="let dds of dropdowns(); let i = index">
            <div *ngIf="rowData.selectedItems?.length > i">
               <vc-single-select-dropdown
                  [items]="rowData.options"
                  optionLabel="name"
                  [filter]="true"
                  [filterBy]="'name'"
                  [selectedItems]="rowData.selectedItems"
                  [setValue]="rowData.selectedItems[i]"
                  [required]="true"
                  variantClass=""
                  sizeClass="v-dropdown-full"
                  placeholder="Make A Selection"
                  (selectionChange)="handleSelectionChanged($event, i)"></vc-single-select-dropdown>
            </div>
         </div>
      </div>
   </div>
</div>
